import sanitizeHtml from 'sanitize-html';

// Санитайзер для HTML из внешних источников (RSS-фиды в импорте, T-18 / MD-30): без script/style,
// без обработчиков событий, только http/https/ftp/mailto/tel в ссылках и картинках.
// Конфиг совпадает с subscribe_pack/lib/sanitizer.js; fantastic/lib/sanitizer.js мягче
// (пропускает <style> и JSON-LD) и для внешнего контента не подходит.
export const clearHtml = html =>
  sanitizeHtml(html, {
    allowedTags: [
      'a','b','br','div','font','h1','h2','h3','h4','h5','h6','head','hr','img','label','li','ol','p',
      'span','strong','table','td','th','tr','u','ul'
    ],
    disallowedTagsMode: 'discard',
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
    allowedAttributes: {
      a: ['href', 'name', 'target', 'class', 'id', 'style'],
      img: ['src', 'align', 'border', 'class', 'height', 'hspace', 'id', 'style', 'usemap', 'vspace', 'width'],
      b: ['class','id','style'],
      br: ['class','id','style'],
      div: ['align','class', 'dir','id','style'],
      font: ['class','color','face','size','id','style'],
      h1: ['align','class', 'dir','id','style'],
      h2: ['align','class', 'dir','id','style'],
      h3: ['align','class', 'dir','id','style'],
      h4: ['align','class', 'dir','id','style'],
      h5: ['align','class', 'dir','id','style'],
      h6: ['align','class', 'dir','id','style'],
      head: ['dir'],
      hr: ['align','size','width'],
      label: ['class','id','style'],
      li: ['class','dir','id','style','type'],
      ol: ['class','dir','id','style','type'],
      p: ['class','dir','id','style','align'],
      span: ['class','id','style'],
      strong: ['class','id','style'],
      table: ['align', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'class', 'dir', 'frame', 'id', 'rules', 'style', 'width'],
      td: ['abbr', 'align', 'bgcolor', 'class', 'colspan', 'dir', 'height', 'id', 'lang', 'rowspan', 'scope', 'style', 'valign', 'width'],
      th: ['abbr', 'align', 'background', 'bgcolor', 'class', 'colspan', 'dir', 'height', 'id', 'lang', 'scope', 'style', 'valign', 'width'],
      tr: ['align', 'bgcolor', 'class', 'dir', 'id', 'style', 'valign'],
      u: ['class', 'id', 'style'],
      ul: ['class', 'dir', 'id', 'style']
    }
  });

// href для ссылок из внешних данных: только http(s)/mailto, иначе '#'
// (React 17 ещё рендерит javascript:-URL, только предупреждая в консоли).
export const safeHref = value => {
  const url = String(value || '').trim();
  return /^(https?:\/\/|mailto:)/i.test(url) ? url : '#';
};

export default clearHtml;
